import React from 'react';
export function ProblemSection() {
  return <section id="problem" className="py-12 md:py-16 text-center" style={{
    background: 'var(--nude)'
  }} data-id="element-219">
      <div className="max-w-[680px] mx-auto px-5" data-id="element-220">
        <h2 className="font-serif font-normal max-w-[620px] mx-auto mb-3" style={{
        fontSize: 'clamp(26px, 4.5vw, 44px)',
        color: 'var(--ink)'
      }} data-id="element-221">
          El problema no sos vos.
          <br data-id="element-222" />
          <em style={{
          color: 'var(--rose-deep)'
        }} data-id="element-223">
            Es que nadie te enseñó a cerrar.
          </em>
        </h2>

        <div className="petal-divider" style={{
        margin: '20px 0'
      }} data-id="element-224">
          · · ·
        </div>

        <div className="text-[15px] text-left leading-relaxed" style={{
        color: 'var(--muted)'
      }} data-id="element-225">
          <p className="mb-4" data-id="element-226">
            Tu mente funciona como una computadora. Cada experiencia emocional
            que no tuvo un cierre real es una{' '}
            <strong style={{
            color: 'var(--ink)',
            fontWeight: 500
          }} data-id="element-227">
              pestaña que quedó abierta
            </strong>
            . No la ves todo el tiempo — pero está ahí,{' '}
            <u data-id="element-228">consumiendo energía</u>, apareciendo cuando menos lo querés.
          </p>

          <div className="text-center my-6 p-6 md:p-8 rounded-xl" style={{
          background: 'linear-gradient(135deg, var(--lilac), var(--blush))',
          border: '1px solid rgba(200,169,110,.3)'
        }} data-id="element-229">
            <h3 className="font-serif font-medium mb-2" style={{
            fontSize: 'clamp(18px, 3vw, 26px)',
            color: 'var(--ink)'
          }} data-id="element-230">
              El Efecto Zeigarnik
            </h3>
            <p className="text-[14px] max-w-[500px] mx-auto leading-relaxed" style={{
            color: 'var(--ink-soft)'
          }} data-id="element-231">
              El cerebro humano está programado para{' '}
              <strong style={{
              color: 'var(--ink)',
              fontWeight: 500
            }} data-id="element-232">
                recordar con más fuerza lo inconcluso que lo resuelto
              </strong>
              . No es voluntad. No es fuerza de carácter. <em data-id="element-233">Es neurología</em>
              . No podés decidir dejar de recordar algo inconcluso, igual que no
              podés decidir dejar de tener hambre.
            </p>
          </div>

          <p className="mb-4" data-id="element-234">
            La terapia te ayudó a <em data-id="element-235">entender</em>. Los libros te dieron
            teoría. La meditación te relajó. Pero{' '}
            <strong style={{
            color: 'var(--ink)',
            fontWeight: 500
          }} data-id="element-236">
              ninguna de esas herramientas, sola, le dice al cerebro que algo
              terminó de verdad
            </strong>
            .
          </p>

          <p className="mb-4" data-id="element-237">Para eso existe este proceso.</p>
        </div>

        <div className="text-center p-6 md:p-7 rounded-lg" style={{
        background: 'var(--ink)'
      }} data-id="element-238">
          <p className="font-serif italic max-w-[500px] mx-auto leading-snug" style={{
          fontSize: 'clamp(16px, 2.8vw, 22px)',
          color: 'var(--gold-light)'
        }} data-id="element-239">
            "No es que no podás soltar. Es que tu mente{' '}
            <u style={{
            textDecorationColor: 'var(--gold)'
          }} data-id="element-240">
              nunca tuvo las herramientas
            </u>{' '}
            para crear ese cierre. Esa es la diferencia."
          </p>
        </div>
      </div>
    </section>;
}